import React, { useEffect, useState } from "react";
import { fetchEvent, fetchItems, deleteItem } from "../api";
import { useParams, Link } from "react-router-dom";
import { 
    Container, Typography, Grid, Card, CardContent, Button, Fab, Divider 
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

const EventDetail = () => {
    const { eventId } = useParams();
    const [event, setEvent] = useState(null);
    const [items, setItems] = useState([]);

    useEffect(() => {
        fetchEvent(eventId).then(setEvent);
        fetchItems(eventId).then(setItems);
    }, [eventId]);

    // 🔥 カテゴリごとにデータを整理
    const groupedItems = items.reduce((acc, item) => {
        const category = item.category1 || "その他";
        if (!acc[category]) acc[category] = [];
        acc[category].push(item);
        return acc;
    }, {});

    // 🔥 削除処理
    const handleDelete = async (itemId) => {
        if (!window.confirm("この品物を削除しますか？")) return;

        try {
            await deleteItem(eventId, itemId);
            alert("品物を削除しました！");
            setItems(items.filter(item => item.itemId !== itemId));
        } catch (error) {
            console.error("❌ エラー:", error);
            alert("エラーが発生しました。");
        }
    };

    return (
        <Container maxWidth="md">
            {/* イベント情報 */}
            <Typography variant="h4" gutterBottom>
                {event ? event.eventName : "イベントを読み込み中..."}
            </Typography>
            <Typography variant="subtitle1" color="textSecondary">
                {event ? `日付: ${event.eventDate}` : ""}
            </Typography>

            {/* 持ち寄りリスト */}
            <Typography variant="h5" style={{ marginTop: "20px" }}>持ち寄りリスト</Typography>

            {Object.keys(groupedItems).length > 0 ? (
                Object.entries(groupedItems).map(([category, items]) => (
                    <div key={category} style={{ marginTop: "20px" }}>
                        {/* カテゴリ名と追加ボタン */}
                        <Typography variant="h6" gutterBottom>
                            {category}
                            <Link to={`/events/${eventId}/add-item`}>
                                <Button size="small" variant="outlined" style={{ marginLeft: "10px" }}>
                                    追加
                                </Button>
                            </Link>
                        </Typography>
                        <Divider />

                        {/* カテゴリごとのアイテムリスト */}
                        <Grid container spacing={2} style={{ marginTop: "10px" }}>
                            {items.map((item) => (
                                <Grid item xs={12} sm={6} md={4} key={item.itemId}>
                                    <Card>
                                        <CardContent>
                                            <Typography color="textSecondary">
                                                {item.category2} > {item.category3}
                                            </Typography>
                                            <Typography variant="h6">{item.itemName}</Typography>
                                            <Typography>数量: {item.quantity}</Typography>
                                            {/* 🔗 参考URLがある場合のみ表示 */}
                                            {item.purchaseUrl && item.purchaseUrl.trim() !== "" && item.purchaseUrl !== "なし" && (
                                            <Typography variant="body2" style={{ marginTop: "5px" }}>
                                                <a href={item.purchaseUrl} target="_blank" rel="noopener noreferrer">
                                                参考URL
                                                </a>
                                            </Typography>
                                            )}

                                            {/* ✅ 画像がある場合のみ表示 */}
                                            {item.imageUrl && (
                                            <img
                                                src={item.imageUrl}
                                                alt={`${item.itemName}の画像`}
                                                style={{ width: "100%", maxHeight: "200px", objectFit: "cover", borderRadius: "4px", marginBottom: "10px" }}
                                            />
                                            )}







                                            <Button 
                                                component={Link} 
                                                to={`/events/${eventId}/items/${item.itemId}/edit`} 
                                                variant="contained" 
                                                size="small" 
                                                color="primary"
                                                style={{ marginRight: "5px" }}
                                            >
                                                編集
                                            </Button>
                                            <Button 
                                                variant="contained" 
                                                size="small" 
                                                color="secondary"
                                                onClick={() => handleDelete(item.itemId)}
                                            >
                                                削除
                                            </Button>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </div>
                ))
            ) : (
                <Typography color="textSecondary" style={{ marginTop: "20px" }}>まだ登録されていません。</Typography>
            )}

            {/* 🔥 フローティングアクションボタン（FAB）を追加 */}
            <Link to={`/events/${eventId}/add-item`}>
                <Fab color="primary" aria-label="add" style={{ position: "fixed", bottom: "20px", right: "20px" }}>
                    <AddIcon />
                </Fab>
            </Link>
        </Container>
    );
};

export default EventDetail;
